"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ImplementationGuide_Manifest = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_url_1 = require("../Scalar/RTTI_url");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_ImplementationGuide_Resource1_1 = require("./RTTI_ImplementationGuide_Resource1");
var RTTI_ImplementationGuide_Page1_1 = require("./RTTI_ImplementationGuide_Page1");
exports.RTTI_ImplementationGuide_Manifest = t.recursion('IImplementationGuide_Manifest', function () {
    return t.intersection([
        t.type({
            resource: t.array(RTTI_ImplementationGuide_Resource1_1.RTTI_ImplementationGuide_Resource1)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            rendering: RTTI_url_1.RTTI_url,
            _rendering: RTTI_Element_1.RTTI_Element,
            page: t.array(RTTI_ImplementationGuide_Page1_1.RTTI_ImplementationGuide_Page1),
            image: t.array(t.string),
            _image: t.array(RTTI_Element_1.RTTI_Element),
            other: t.array(t.string),
            _other: t.array(RTTI_Element_1.RTTI_Element)
        })
    ]);
});
//# sourceMappingURL=RTTI_ImplementationGuide_Manifest.js.map